import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import styles from '../index.styl';

const InfoContent = ({ value }) => {
  if (Array.isArray(value)) {
    const children = value.reduce((list, item, i) => {
      const child = <li key={i}>{item}</li>;
      list.push(child);

      return list;
    }, []);

    return <ul>{children}</ul>;
  }

  return <p>{value}</p>;
};

InfoContent.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]).isRequired,
};

export default CSSModules(InfoContent, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/InfoBtn/InfoContent/index.jsx